export default __webpack_public_path__ + "static/kreislauf-ed24d4ce6f27a3872bb41f3f7d71fe2e.svg";